import React from 'react';
import Note from './Note';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import { Redirect } from 'react-router-dom';
import { getAgenciesFullPermission } from 'reducers/PermissionsReducer';

function NotesSearch() {
  const canReadAgencies = getAgenciesFullPermission('cad', 'Events', 'Read');
  if (!canReadAgencies.length) return <Redirect to="/" />;
  return (
    <SearchMenu agencyList={canReadAgencies}>
      <FilterConsumer>{(AgencyFilter) => <Note filter={AgencyFilter} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default NotesSearch;
